import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplayIcon from "@mui/icons-material/Replay";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "../../context/authContext";
import { useTransaksi } from "../../context/transaksiContext";
import useItem from "../../services/queries/useItem";
import usePiutang from "../../services/queries/usePiutang";
import toRupiah from "../../utils/toRupiah";
import CardPesan from "../CardPesan/CardPesan";
import DaftarPiutang from "../DaftarPiutang/DaftarPiutang";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import { LoadingButton } from "@mui/lab";
import {
    Card,
    Checkbox,
    FormControlLabel,
    IconButton,
    InputAdornment,
    Tooltip,
} from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import ToggleButton from "@mui/material/ToggleButton";
import { BlobProvider } from "@react-pdf/renderer";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";
import { ReactComponent as BelumAdaPesanan } from "../../assets/images/BelumAdaPesanan.svg";
import logoUloGif from "../../assets/images/LoadingUlo.gif";
import {
    DetailBundling,
    IFaktur,
    InputPembayaranResponse,
    IOptions,
    ParamsGetItem,
    ParamsGetListInvoice,
    PiutangParams,
    TipeStruk,
} from "../../constants/types";
import axios from "../../services/axios";
import useListInvoice from "../../services/queries/useListInvoice";
import useUkm from "../../services/queries/useUkm";
import useUser from "../../services/queries/useUser";
import { getLocalUkmId } from "../../utils/handleChangeUkmId";
import CardInvoiceTransaction from "../CardInvoiceTransaction/CardInvoiceTransaction";
import ModalBayar from "../ModalBayar/ModalBayar";
import ModalKonfirmasiBayar from "../ModalKonfirmasiBayar/ModalKonfirmasiBayar";
import PayIcon from "../PayIcon";
import PrintStrukDapur from "../PrintStruk/PrintStrukDapur";

interface IListPesanProps {
    handleIsError: () => void;
}

enum SectionPesan {
    Keranjang = "SATUAN",
    OpenBill = "OPENBILL",
    Invoice = "INVOICE",
    Piutang = "PIUTANG",
}

type DateFilter = [Date | null, Date | null];

const ListPesan = ({ handleIsError }: IListPesanProps) => {
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.between("xs", "md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));

    const [isScanBarcode, setIsScanBarcode] = useState<boolean>(false);
    const { ukmIdUser } = useAuth();
    const {
        totalHarga,
        addToCart,
        cart,
        resetCart,
        openModalBayar,
        handleReset,
        isKeterangan,
        handleIsKeterangan,
        // keteranganBeli,
        // handleChangeKeteranganBeli,
        setPaymentMode,
        openBill,
        setOpenBill,
    } = useTransaksi();

    let today = new Date();

    const [diskon, setDiskon] = useState<number>();
    const [persentaseDiskon, setPersentaseDiskon] = useState<number | null>();
    const [pajak, setPajak] = useState<number>();
    const [persentasePajak, setPersentasePajak] = useState<number | null>();
    const [service, setService] = useState<number>();
    const [persentaseService, setPersentaseService] = useState<number | null>();
    const [tagihan, setTagihan] = useState<number>();
    const [uangDibayar, setUangDibayar] = useState<number>();
    const [kembalian, setKembalian] = useState<number>();
    const [sales, setSales] = useState<IOptions | null>(null);

    const [sku, setSku] = useState<string>("");
    const [inputSku, setInputSku] = useState<string>("");
    const [section, setSection] = useState<SectionPesan>(
        SectionPesan.Keranjang,
    );

    const initialParamsItem = {
        ukmId: undefined,
        size: 1000,
        isShow: 0,
        page: 1,
        search: "",
        kategori: "",
    };
    const [paramsItem, setParamsItem] =
        useState<ParamsGetItem>(initialParamsItem);
    const {
        data: item,
        refetch: refetchItem,
        isError: isErrorItem,
    } = useItem(paramsItem);

    const moment = require("moment");
    let now = moment().format("YYYY/MM/DD");
    let nowDapur = moment().format("YYYY/MM/DD HH:mm");

    const [dateRange, setDateRange] = useState<DateFilter>([
        new Date(),
        new Date(),
    ]);
    const [startDate, endDate] = dateRange;

    const initialParamsListInvoice = {
        ukmId: ukmIdUser && ukmIdUser[0],
        search: "",
        size: 100,
        page: 1,
        tanggalAwal: now,
        tanggalAkhir: now,
        kasir: "",
        sales: "",
        metodeId: "",
        voidInvoice: "",
    };

    const {
        data: listInvoice,
        refetch: refetchListInvoice,
        isError: isErrorListInvoice,
    } = useListInvoice(initialParamsListInvoice);

    const transaksiKe =
        (Number(listInvoice?.content?.[0]?.transaksiKe) || 0) + 1;

    const initialParamsListOpenBill = {
        ukmId: ukmIdUser && ukmIdUser[0],
        search: "",
        size: 100,
        page: 1,
        tanggalAwal: now,
        tanggalAkhir: now,
        kasir: "",
        sales: "",
        metodeId: "",
        voidInvoice: "",
        openBill: 1,
    };

    const [paramsListOpenBill, setParamsListOpenBill] =
        useState<ParamsGetListInvoice>(initialParamsListOpenBill);

    const {
        data: listOpenBill,
        refetch: refetchListOpenBill,
        isLoading: isLoadingListOpenBill,
    } = useListInvoice(paramsListOpenBill);

    const handleChangePeriodeOpenBill = (event: SelectChangeEvent) => {
        setDateRange([new Date(event.target.value), new Date()]);

        setParamsListOpenBill((prev) => ({
            ...prev,
            tanggalAwal: String(event.target.value),
            tanggalAkhir: now,
            page: 1,
        }));

        refetchListOpenBill();
    };

    const handleChangeJangkaWaktuOpenBill = (
        tanggalAwal: string,
        tanggalAkhir: string,
    ) => {
        setParamsListOpenBill((prev) => ({
            ...prev,
            tanggalAwal: tanggalAwal,
            tanggalAkhir: tanggalAkhir,
            page: 1,
        }));

        refetchListOpenBill();
    };

    function subtractYears(numOfYears: number, date = new Date()) {
        date.setFullYear(date.getFullYear() - numOfYears);

        return date;
    }

    const { data: user } = useUser();

    const initialParamsUkm = {
        size: 500,
        page: 1,
        search: "",
    };
    const { data: ukm } = useUkm(initialParamsUkm);

    const initialPiutangParams = {
        ukmId: ukmIdUser && ukmIdUser[0],
        search: "",
        size: 100,
        page: 1,
        piutang: 1,
        urutan: 2,
    };
    const [piutangParams, setPiutangParams] =
        useState<PiutangParams>(initialPiutangParams);
    const { data: debt } = usePiutang(piutangParams);

    const ukmId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalUkmId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const ukmData = React.useMemo(() => {
        if (ukmId) {
            return ukm?.content.find((li) => li.id === ukmId);
        }
        return ukm?.content[0];
    }, [ukm?.content, ukmId]);

    const [printStruk, setPrintStruk] = useState(
        localStorage.getItem(`printStruk_${ukmId}`) === "true",
    );

    // const [tipeStruk, setTipeStruk] = useState<string | null>(
    //     localStorage.getItem(`tipeStrukDapur_${ukmId}`) ?? TipeStruk.MobileDapur,
    // );

    const [tipeStruk, setTipeStruk] = useState<string>(() => {
        const key = `tipeStrukDapur_${ukmId}`;
        const storedValue = localStorage.getItem(key);

        if (storedValue === null) {
            const defaultValue = TipeStruk.MobileDapur;
            localStorage.setItem(key, defaultValue);
            return defaultValue;
        }

        return storedValue;
    });

    // const [isIncludeDapur, setIsIncludeDapur] = useState<boolean>(
    //     localStorage.getItem(`strukDapur_${ukmId}`) === "true"
    // );

    const [isIncludeDapur, setIsIncludeDapur] = useState<boolean>(() => {
        const key = `strukDapur_${ukmId}`;
        const storedValue = localStorage.getItem(key);

        if (storedValue === null) {
            localStorage.setItem(key, "true");
            return true;
        }

        // Selalu return true terlepas dari nilai yang tersimpan
        return true;
    });

    const handleTipeStruk = (
        _event: React.MouseEvent<HTMLElement>,
        newTipeStruk: TipeStruk | null,
    ) => {
        if (newTipeStruk !== null) {
            setTipeStruk(newTipeStruk);
            localStorage.setItem(`tipeStrukDapur_${ukmId}`, newTipeStruk);

            const isDapur =
                newTipeStruk === TipeStruk.MobileDapur ||
                newTipeStruk === TipeStruk.Mobile80Dapur;
            setIsIncludeDapur(isDapur);
            localStorage.setItem(`strukDapur_${ukmId}`, String(isDapur));
        }
    };

    const handlePrintStruk = (checked: boolean) => {
        if (checked) {
            setPrintStruk(true);
            localStorage.setItem(`printStruk_${ukmId}`, "true");
        } else {
            setPrintStruk(false);
            localStorage.removeItem(`printStruk_${ukmId}`);
            localStorage.removeItem(`tipeStrukDapur_${ukmId}`);
        }
    };

    const {
        isFetchingItems,
        setFetchingItems,
        cancelFetchingItems,
        selectedDebt,
        setSelectedDebt,
    } = useTransaksi();

    const [keteranganBeli, setKeteranganBeli] = useState<string>("");

    // const [transaksiKe, setTransaksiKe] = useState("");

    const resetKeteranganBeli = useCallback(() => {
        setKeteranganBeli("");
    }, []);

    const handleChangeKeteranganBeli = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setKeteranganBeli(event.target.value);
    };

    const handlingRincianPembayaran = (
        persentaseDiskon: number | null,
        diskon: number | null,
        persentasePajak: number | null,
        pajak: number | null,
        serviceCustom: number | null,
        serviceCustomPersen: number | null,
        tagihan: number,
        uangYangDibayar: number,
        kembalian: number,
        sales: IOptions | null,
    ) => {
        if (diskon && diskon > 0) {
            setDiskon(diskon);
        } else {
            setDiskon(0);
        }
        if (persentaseDiskon !== null) {
            setPersentaseDiskon(persentaseDiskon);
        }
        if (pajak && pajak > 0) {
            setPajak(pajak);
        } else {
            setPajak(0);
        }
        if (persentasePajak !== null) {
            setPersentasePajak(persentasePajak);
        }
        if (serviceCustom && serviceCustom > 0) {
            setService(serviceCustom);
        } else {
            setService(0);
        }
        if (serviceCustomPersen !== null) {
            setPersentaseService(persentaseService);
        }
        setTagihan(tagihan);
        setUangDibayar(uangYangDibayar);
        setKembalian(kembalian);
        setSales(sales);
    };

    function handleDebtPayment() {
        if (!selectedDebt) return;

        setPaymentMode("debt");
    }

    type InvoiceItem = {
        id: number;
        namaBarang: string;
        // namaKategori: string;
        kategori: {
            id: number;
            nama: string;
        };
        sku: string | number;
        harga: number;
        stok: number;
        url: string;
        jumlahItem: number;
        detailBundling: DetailBundling[] | [];
        hpp: {
            id: number;
            faktur: string;
            hargaBeli: number;
            jumlah: number;
        }[];
        hargaMultiple: {
            id: number;
            harga: number;
            keterangan: string | null;
        }[];
        hargaSatuan: string;
        keteranganItem: string | null;
    };

    type ICart = {
        id: number;
        namaBarang: string;
        namaKategori: string;
        sku: string;
        harga: number;
        url: string;
        qty: number;
        jumlahStok: number | undefined;
        detailBundling: DetailBundling[] | [];
        hpp: {
            id: number;
            faktur: string;
            hargaBeli: number;
            jumlah: number;
        }[];
        faktur: IFaktur[];
        multipleHarga: {
            id: number;
            harga: number;
            keterangan: string | null;
        }[];
        keteranganItem: string | null;
        hargaSatuan: string;
    };

    const [cartOpenBill, setCartOpenBill] = useState<any[]>([]);
    const [invoiceId, setInvoiceId] = useState<string | null>(null);
    const [cartItems, setCartItems] = useState<InvoiceItem[]>([]);

    // const handleAddToCart = (invoice: any) => {
    //     if (openBill === 0) {
    //         setOpenBill(1);
    //         localStorage.setItem(
    //             `openBill_${ukmId}`,
    //             JSON.stringify({ openBill: 1, cart: [], ukmId }),
    //         );

    //         setPrintStruk(true);
    //         localStorage.setItem(`printStruk_${ukmId}`, 'true');
    //         localStorage.setItem(`tipeStrukDapur_${ukmId}`, TipeStruk.MobileDapur);
    //     }

    //     if (!invoice?.daftarItem || invoice.daftarItem.length === 0) return;

    //     if (invoice.ketBeli) {
    //         handleIsKeterangan(true);
    //         setKeteranganBeli(invoice.ketBeli);
    //     } else {
    //         handleIsKeterangan(false);
    //         setKeteranganBeli('');
    //     }

    //     resetCart();
    //     setCartItems([]);

    //     invoice.daftarItem.forEach((item: InvoiceItem) => {
    //         const existingItem = cart.find(
    //             (cartItem) => cartItem.id === item.id,
    //         );

    //         if (!existingItem) {
    //             addToCart({
    //                 id: item.id,
    //                 namaBarang: item.namaBarang,
    //                 namaKategori: item.kategori.nama,
    //                 sku: String(item.sku),
    //                 harga: item.harga,
    //                 url: item.url,
    //                 jumlahStok: item.stok,
    //                 qty: item.jumlahItem,
    //                 detailBundling: item.detailBundling,
    //                 hpp: item.hpp,
    //                 multipleHarga: item.hargaMultiple,
    //                 faktur: [],
    //                 keteranganItem: item.keteranganItem,
    //             });
    //         }
    //     });

    //     setCartOpenBill((prevCart) => [...prevCart, invoice]);
    //     setInvoiceId(invoice.id);
    //     setSection(SectionPesan.Keranjang);
    //     setCartItems((prevItems) => [...prevItems, ...invoice.daftarItem]);
    // };

    const handleAddToCart = (invoice: any) => {
        if (openBill === 0) {
            setOpenBill(1);
            localStorage.setItem(
                `openBill_${ukmId}`,
                JSON.stringify({ openBill: 1, cart: [], ukmId }),
            );

            setPrintStruk(true);
            localStorage.setItem(`printStruk_${ukmId}`, "true");
            localStorage.setItem(
                `tipeStrukDapur_${ukmId}`,
                TipeStruk.MobileDapur,
            );
        }

        if (!invoice?.daftarItem || invoice.daftarItem.length === 0) return;

        if (invoice.ketBeli) {
            handleIsKeterangan(true);
            setKeteranganBeli(invoice.ketBeli);
        } else {
            handleIsKeterangan(false);
            setKeteranganBeli("");
        }

        resetCart();
        setCartItems([]);

        invoice.daftarItem.forEach((item: InvoiceItem) => {
            const existingItem = cart.find(
                (cartItem) => cartItem.id === item.id,
            );

            if (!existingItem) {
                // console.log(item.hargaSatuan + "tstt");

                // const matchingPrice = item.hargaMultiple?.find(
                //     (h: any) => h.harga === item.hargaSatuan
                // );

                // const selectedPrice = matchingPrice ? matchingPrice.harga : item.hargaSatuan;

                addToCart({
                    id: item.id,
                    namaBarang: item.namaBarang,
                    namaKategori: item.kategori.nama,
                    sku: String(item.sku),
                    harga: item.harga,
                    // harga: selectedHargaMultiple ? selectedHargaMultiple.harga : item.hargaSatuan,
                    // harga: selectedPrice,
                    url: item.url,
                    jumlahStok: item.stok,
                    qty: item.jumlahItem,
                    detailBundling: item.detailBundling,
                    hpp: item.hpp,
                    multipleHarga: item.hargaMultiple,
                    faktur: [],
                    keteranganItem: item.keteranganItem,
                    hargaSatuan: item.hargaSatuan,
                });
            }
        });

        setCartOpenBill((prevCart) => [...prevCart, invoice]);
        setInvoiceId(invoice.id);
        setSection(SectionPesan.Keranjang);
        setCartItems((prevItems) => [...prevItems, ...invoice.daftarItem]);
    };

    const updatedCart = cart.reduce(
        (acc, cartItem) => {
            const invoiceItem = cartItems.find((inv) => inv.id === cartItem.id);

            if (!invoiceItem) {
                acc.push(cartItem);
            } else {
                const invoiceQty =
                    invoiceItem.jumlahItem ?? invoiceItem.jumlahItem ?? 0;
                const cartQty = cartItem.qty ?? cartItem.jumlahStok ?? 0;

                const diffQty = cartQty - invoiceQty;
                if (diffQty > 0) {
                    acc.push({
                        ...cartItem,
                        qty: diffQty,
                    });
                }
            }
            return acc;
        },
        [] as typeof cart,
    );

    const handleAddToCartEndOpenBill = (invoice: any) => {
        if (!invoice?.daftarItem || invoice.daftarItem.length === 0) return;

        invoice.daftarItem.forEach((item: InvoiceItem) => {
            const existingItem = cart.find(
                (cartItem) => cartItem.id === item.id,
            );

            if (!existingItem) {
                addToCart({
                    id: item.id,
                    namaBarang: item.namaBarang,
                    namaKategori: item.kategori.nama,
                    sku: String(item.sku),
                    harga: item.harga,
                    url: item.url,
                    jumlahStok: item.stok,
                    qty: item.jumlahItem,
                    detailBundling: item.detailBundling,
                    hpp: item.hpp,
                    multipleHarga: item.hargaMultiple,
                    faktur: [],
                    keteranganItem: item.keteranganItem,
                    hargaSatuan: item.hargaSatuan,
                });
            }
        });

        if (openBill !== 1) {
            localStorage.removeItem(`openBill_${ukmId}`);
        } else {
            localStorage.setItem(
                `openBill_${ukmId}`,
                JSON.stringify({ openBill: 1, cart: [], ukmId }),
            );
        }
    };

    const handleRemoveFromCartItems = (id: string | number) => {
        setCartItems((prevItems) => prevItems.filter((item) => item.id !== id));
    };

    const handleSwitchChange = (event: { target: { checked: boolean } }) => {
        const isChecked = event.target.checked;
        setOpenBill(isChecked ? 1 : 0);

        if (isChecked) {
            localStorage.setItem(
                `openBill_${ukmId}`,
                JSON.stringify({ openBill: 1, cart, ukmId }),
            );

            setPrintStruk(true);
            localStorage.setItem(`printStruk_${ukmId}`, "true");
            localStorage.setItem(
                `tipeStrukDapur_${ukmId}`,
                TipeStruk.MobileDapur,
            );
        } else {
            localStorage.removeItem(`openBill_${ukmId}`);
            localStorage.removeItem(`printStruk_${ukmId}`);
            localStorage.removeItem(`tipeStrukDapur_${ukmId}`);
            setPrintStruk(false);
        }

        console.log({ openBill: isChecked ? 1 : 0 });
    };

    const firstLoad = useRef(true);

    useEffect(() => {
        if (!firstLoad.current) return;
        firstLoad.current = false;

        const storedData = localStorage.getItem(`openBill_${ukmId}`);

        if (storedData) {
            try {
                const parsedData = JSON.parse(storedData);

                if (parsedData && typeof parsedData === "object") {
                    const { openBill, cart } = parsedData;

                    if (openBill !== undefined) {
                        setOpenBill(openBill);
                    }

                    if (Array.isArray(cart) && cart.length > 0) {
                        cart.forEach((item: ICart) => {
                            addToCart({
                                id: item.id,
                                namaBarang: item.namaBarang,
                                namaKategori: item.namaKategori,
                                sku: String(item.sku),
                                harga: item.harga,
                                url: item.url,
                                jumlahStok: item.jumlahStok,
                                qty: item.qty,
                                detailBundling: item.detailBundling || [],
                                hpp: item.hpp || [],
                                multipleHarga: item.multipleHarga || [],
                                hargaSatuan: item.hargaSatuan,
                                faktur: [],
                                keteranganItem: item.keteranganItem,
                            });
                        });
                    }
                }
            } catch (error) {
                console.error("Error parsing localStorage data:", error);
            }
        }
    }, [addToCart, setOpenBill, ukmId]);

    useEffect(() => {
        const handleLocalStorageChange = () => {
            const storedData = localStorage.getItem(`openBill_${ukmId}`);

            if (storedData) {
                try {
                    const parsedData = JSON.parse(storedData);

                    if (parsedData && typeof parsedData === "object") {
                        const { openBill, cart } = parsedData;

                        if (openBill !== undefined) {
                            setOpenBill(openBill);
                        }

                        if (Array.isArray(cart) && cart.length > 0) {
                            cart.forEach((item: ICart) => {
                                addToCart({
                                    id: item.id,
                                    namaBarang: item.namaBarang,
                                    namaKategori: item.namaKategori,
                                    sku: String(item.sku),
                                    harga: item.harga,
                                    url: item.url,
                                    jumlahStok: item.jumlahStok,
                                    qty: item.qty,
                                    detailBundling: item.detailBundling || [],
                                    hpp: item.hpp || [],
                                    multipleHarga: item.multipleHarga || [],
                                    hargaSatuan: item.hargaSatuan,
                                    faktur: [],
                                    keteranganItem: item.keteranganItem,
                                });
                            });
                        }
                    }
                } catch (error) {
                    console.error("Error parsing localStorage data:", error);
                }
            }
        };

        window.addEventListener("localStorageChange", handleLocalStorageChange);

        return () => {
            window.removeEventListener(
                "localStorageChange",
                handleLocalStorageChange,
            );
        };
    }, [ukmId, addToCart, setOpenBill]);

    useEffect(() => {
        if (openBill === 1 && cart.length > 0) {
            localStorage.setItem(
                `openBill_${ukmId}`,
                JSON.stringify({ openBill, cart, ukmId }),
            );
        }
    }, [cart, openBill, ukmId]);

    useEffect(() => {
        if (isFetchingItems) {
            refetchListInvoice();
            cancelFetchingItems();
        }
    }, [cancelFetchingItems, isFetchingItems, refetchListInvoice]);

    useEffect(() => {
        if (isErrorItem || isErrorListInvoice) {
            handleIsError();
        }
    }, [handleIsError, isErrorItem, isErrorListInvoice]);

    const [search, setSearch] = useState("");
    const [filteredInvoicesOpenBill, setFilteredInvoicesOpenBill] = useState(
        listOpenBill?.content || [],
    );

    useEffect(() => {
        if (listOpenBill?.content) {
            setFilteredInvoicesOpenBill(
                listOpenBill.content.filter(
                    (li) =>
                        li.nomorInvoice
                            .toLowerCase()
                            .includes(search.toLowerCase()) ||
                        li.keterangan
                            ?.toLowerCase()
                            .includes(search.toLowerCase()),
                ),
            );
        }
    }, [search, listOpenBill]);

    useEffect(() => {
        if (isScanBarcode) {
            setParamsItem((prev) => ({
                ...prev,
                ukmId: ukmIdUser && ukmIdUser[0],
            }));
        }
    }, [isScanBarcode, ukmIdUser]);

    useEffect(() => {
        if (inputSku !== "") {
            setSku("");
            setInputSku("");
            const selectedProduct = item?.content.filter(
                (list) => list.sku === sku,
            )[0];
            // const index = cart.findIndex((c) => {
            //     return c.id === selectedProduct?.id;
            // });

            if (
                (selectedProduct && selectedProduct?.stok > 0) ||
                selectedProduct?.stok === null
            ) {
                addToCart({
                    id: Number(selectedProduct?.id),
                    namaBarang: String(selectedProduct?.namaBarang),
                    namaKategori: String(selectedProduct?.kategori.nama),
                    sku: String(selectedProduct?.sku),
                    harga: Number(selectedProduct?.harga),
                    url: String(selectedProduct?.gambar),
                    jumlahStok: selectedProduct?.stok ?? null,
                    qty: 1,
                    detailBundling: selectedProduct.detailBundling,
                    hpp: selectedProduct.hpp,
                    faktur: [],
                    multipleHarga: selectedProduct.hargaMultiple.map((li) => ({
                        id: li.id,
                        harga: Number(li.harga),
                        keterangan: li.keterangan,
                    })),
                    keteranganItem: selectedProduct.keteranganItem,
                    hargaSatuan: selectedProduct.hargaSatuan,
                });
                // if (cart.length <= 0) {
                //     addToCart({
                //         id: Number(selectedProduct?.id),
                //         namaBarang: String(selectedProduct?.namaBarang),
                //         sku: String(selectedProduct?.sku),
                //         harga: Number(selectedProduct?.harga),
                //         url: String(selectedProduct?.gambar),
                //         jumlahStok: selectedProduct?.stok ?? null,
                //         qty: 1,
                //         detailBundling: selectedProduct.detailBundling,
                //     });
                // } else if (cart.length > 0) {
                //     if (
                //         (selectedProduct &&
                //             selectedProduct?.stok > cart[index]?.qty) ||
                //         selectedProduct?.stok === null
                //     ) {
                //         addToCart({
                //             id: Number(selectedProduct?.id),
                //             namaBarang: String(selectedProduct?.namaBarang),
                //             sku: String(selectedProduct?.sku),
                //             harga: Number(selectedProduct?.harga),
                //             url: String(selectedProduct?.gambar),
                //             jumlahStok: selectedProduct?.stok ?? null,
                //             qty: 1,
                //             detailBundling: selectedProduct.detailBundling,
                //         });
                //     } else {
                //         Swal.fire({
                //             title: "Stok Barang tidak mencukupi",
                //             position: "top-end",
                //             showConfirmButton: false,
                //             icon: "error",
                //             toast: true,
                //             timer: 3000,
                //             timerProgressBar: true,
                //             showCloseButton: true,
                //         });
                //     }
                // }
            } else if (selectedProduct && selectedProduct?.stok <= 0) {
                Swal.fire({
                    title: "Barang telah habis",
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "error",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
            } else {
                Swal.fire({
                    title: "Barang tidak ditemukan",
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "error",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });
            }
        }
    }, [addToCart, cart, inputSku, item?.content, sku, ukmIdUser]);

    const [isButtonLoading, setIsButtonLoading] = useState(false);

    const handlingOpenBill = async () => {
        setIsButtonLoading(true);
        const body = {
            ukmId: ukmIdUser && ukmIdUser[0],
            jenisItem: cart.map((li) => ({
                itemId: li.id,
                namaItem: li.namaBarang,
                namaKategori: li.namaKategori,
                skuItem: li.sku,
                jumlahItem: li.qty,
                hargaSatuan: li.harga,
                hargaTotal: li.harga * li.qty,
                kodeFaktur: null,
                keteranganItem: li.keteranganItem || null,
            })),
            totalHarga: totalHarga,
            totalPembayaran: totalHarga,
            diskon: 0,
            uangYangDibayar: 0,
            kembalian: 0,
            metodeId: 0,
            userInput: `${user?.userId}`,
            openBill: openBill,
            keterangan: !!keteranganBeli ? keteranganBeli : null,
        };

        try {
            const { data } = await axios.post<InputPembayaranResponse>(
                "/api/pembayaran",
                body,
            );
            if (data.code === 200) {
                // setTransaksiKe(String(data.data.transaksiKe));
                // console.log("Data transaksiKe:", String(data.data.transaksiKe));
                Swal.fire({
                    title: "Transaksi berhasil!",
                    text: "Open Bill Anda telah berhasil",
                    icon: "success",
                    confirmButtonColor: "#45A779",
                    customClass: {
                        container: "my-swal",
                    },
                });

                // localStorage.removeItem(`openBill_${ukmId}`);

                if (openBill !== 1) {
                    localStorage.removeItem(`openBill_${ukmId}`);
                } else {
                    localStorage.setItem(
                        `openBill_${ukmId}`,
                        JSON.stringify({ openBill: 1, cart: [], ukmId }),
                    );
                }

                setFetchingItems();
                setOpenBill(openBill);
                handleReset();
                setIsButtonLoading(false);
                handleIsKeterangan(false);
            }
        } catch (error: any) {
            setIsButtonLoading(false);

            if (error.response && error.response.status === 400) {
                const errorMessage =
                    error.response.data.message || error.response.data.data;
                Swal.fire({
                    title: "Gagal Memproses Transaksi",
                    text: errorMessage,
                    icon: "error",
                    confirmButtonColor: "#D32F2F",
                    customClass: {
                        container: "my-swal",
                    },
                });
            } else {
                Swal.fire({
                    title: "Terjadi Kesalahan",
                    text: "Terjadi kesalahan saat memproses transaksi",
                    icon: "error",
                    position: "top-end",
                    confirmButtonColor: "#D32F2F",
                    customClass: {
                        container: "my-swal",
                    },
                });
            }
        }
    };

    const handlingUpdateOpenBill = async () => {
        setIsButtonLoading(true);

        const body = {
            jenisItem: cart.map((li) => ({
                itemId: li.id,
                namaItem: li.namaBarang,
                namaKategori: li.namaKategori,
                skuItem: li.sku,
                jumlahItem: li.qty,
                hargaSatuan: li.harga,
                hargaTotal: li.harga * li.qty,
                kodeFaktur: null,
                keteranganItem: li.keteranganItem || null,
            })),
            totalHarga: totalHarga,
            totalPembayaran: totalHarga,
            diskon: 0,
            keterangan: !!keteranganBeli ? keteranganBeli : null,
        };

        try {
            const { data } = await axios.put<InputPembayaranResponse>(
                `/api/pembayaran/${invoiceId}`,
                body,
            );

            if (data.code === 200) {
                Swal.fire({
                    title: "Update Open Bill berhasil!",
                    text: "Update Open Bill Anda berhasil",
                    icon: "success",
                    confirmButtonColor: "#45A779",
                    customClass: { container: "my-swal" },
                });

                // localStorage.removeItem(`openBill_${ukmId}`);

                if (openBill !== 1) {
                    localStorage.removeItem(`openBill_${ukmId}`);
                } else {
                    localStorage.setItem(
                        `openBill_${ukmId}`,
                        JSON.stringify({ openBill: 1, cart: [], ukmId }),
                    );
                }

                setFetchingItems();
                refetchListInvoice();
                setCartOpenBill([]);
                setOpenBill(openBill);
                handleReset();
                handleIsKeterangan(false);
            }
        } catch (error: any) {
            console.error("Terjadi kesalahan:", error);

            if (error.response && error.response.status === 400) {
                const errorMessage =
                    error.response.data.message || error.response.data.data;
                Swal.fire({
                    title: "Gagal Memproses Transaksi",
                    text: errorMessage,
                    icon: "error",
                    confirmButtonColor: "#D32F2F",
                    customClass: {
                        container: "my-swal",
                    },
                });
            } else {
                Swal.fire({
                    title: "Terjadi Kesalahan",
                    text: "Terjadi kesalahan saat memproses transaksi",
                    icon: "error",
                    position: "top-end",
                    confirmButtonColor: "#D32F2F",
                    customClass: {
                        container: "my-swal",
                    },
                });
            }
        } finally {
            setIsButtonLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Box
                display="grid"
                gridTemplateRows="auto auto 1fr auto auto"
                height="calc(100vh - 230px)"
            >
                {/* <Box
                display="grid"
                gridTemplateRows="auto auto 1fr auto auto"
                sx={{
                    height: isPhoneScreen
                        ? ukmData &&
                          ukmIsDueExpired &&
                          ukmIsDueExpired.totalElements > 0 &&
                          ukmIsDueExpired.content.filter(
                              (list) => list.id === ukmData.id,
                          ).length > 0
                            ? "calc(100vh - 98px)"
                            : "calc(100vh - 56px)"
                        : isLaptopScreen
                        ? ukmData &&
                          ukmIsDueExpired &&
                          ukmIsDueExpired.totalElements > 0 &&
                          ukmIsDueExpired.content.filter(
                              (list) => list.id === ukmData.id,
                          ).length > 0
                            ? "calc(100vh - 48.75px)"
                            : "100vh"
                        : "calc(100vh - 64px)",
                }}
            > */}
                <Box paddingTop={2} paddingX={2}>
                    <ToggleButtonGroup
                        color="primary"
                        value={section}
                        exclusive
                        size="small"
                        onChange={(_, value) => {
                            if (value !== null) {
                                setSection(value);
                            }
                        }}
                        fullWidth
                    >
                        <ToggleButton value={SectionPesan.Keranjang}>
                            Keranjang
                        </ToggleButton>
                        <ToggleButton value={SectionPesan.OpenBill}>
                            Open Bill
                        </ToggleButton>
                        <ToggleButton value={SectionPesan.Invoice}>
                            Daftar Transaksi
                        </ToggleButton>
                        <ToggleButton value={SectionPesan.Piutang}>
                            Daftar Piutang
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                {section === SectionPesan.Keranjang && (
                    <React.Fragment>
                        <Box>
                            <Box
                                display="grid"
                                gridTemplateColumns="1fr auto"
                                marginX={2}
                                marginY={1}
                                gap={2}
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Typography
                                    variant={isTabletScreen ? "body2" : "h6"}
                                    fontSize={
                                        isPhoneScreen ? "18px" : undefined
                                    }
                                    fontWeight="bold"
                                >
                                    Barang yang Dipesan
                                </Typography>
                                {/* <Button
                        variant="contained"
                        onClick={() => setIsScanBarcode(!isScanBarcode)}
                        startIcon={<IoBarcodeOutline size={32} />}
                        size="medium"
                    >
                        Mode Barcode
                    </Button> */}
                                <Stack direction="row" spacing={2}>
                                    <Stack
                                        direction="column"
                                        spacing={0}
                                        alignItems="center"
                                    >
                                        <Typography
                                            variant="body2"
                                            fontSize="0.75rem"
                                            fontWeight="bold"
                                        >
                                            Open Bill
                                        </Typography>

                                        <ClickAwayListener
                                            onClickAway={() =>
                                                setOpenBill(openBill)
                                            }
                                        >
                                            <Stack
                                                direction="row"
                                                spacing={0}
                                                alignItems="center"
                                            >
                                                <Typography
                                                    variant="body2"
                                                    fontSize="0.75rem"
                                                >
                                                    Off
                                                </Typography>
                                                <Switch
                                                    checked={openBill === 1}
                                                    size="small"
                                                    onChange={
                                                        handleSwitchChange
                                                    }
                                                    disabled={
                                                        cartOpenBill.length > 0
                                                    }
                                                    inputProps={{
                                                        "aria-label":
                                                            "Scan Barcode",
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    fontSize="0.75rem"
                                                >
                                                    On
                                                </Typography>
                                            </Stack>
                                        </ClickAwayListener>
                                    </Stack>
                                    <Stack
                                        direction="column"
                                        spacing={0}
                                        alignItems="center"
                                    >
                                        <Typography
                                            variant="body2"
                                            fontSize="0.75rem"
                                            fontWeight="bold"
                                        >
                                            Mode Barcode
                                        </Typography>
                                        <ClickAwayListener
                                            onClickAway={() =>
                                                setIsScanBarcode(false)
                                            }
                                        >
                                            <Stack
                                                direction="row"
                                                spacing={0}
                                                alignItems="center"
                                            >
                                                <Typography
                                                    variant="body2"
                                                    fontSize="0.75rem"
                                                >
                                                    Off
                                                </Typography>
                                                <Switch
                                                    checked={isScanBarcode}
                                                    size="small"
                                                    onChange={() =>
                                                        setIsScanBarcode(
                                                            (prev) => !prev,
                                                        )
                                                    }
                                                    inputProps={{
                                                        "aria-label":
                                                            "controlled",
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    fontSize="0.75rem"
                                                >
                                                    On
                                                </Typography>
                                            </Stack>
                                        </ClickAwayListener>
                                    </Stack>
                                </Stack>
                                {/* <Link
                        onClick={() => setIsScanBarcode(!isScanBarcode)}
                        sx={{ display: "flex", cursor: "pointer" }}
                    >
                        <IoBarcodeOutline size={32} />
                    </Link> */}
                            </Box>
                            {isScanBarcode && (
                                <Stack
                                    marginLeft={2}
                                    marginBottom={3}
                                    spacing={2}
                                    direction="row"
                                    alignItems="center"
                                >
                                    <Typography
                                        variant={
                                            isTabletScreen || isPhoneScreen
                                                ? "caption"
                                                : "subtitle2"
                                        }
                                    >
                                        Input SKU (Scan)
                                    </Typography>
                                    <TextField
                                        value={sku}
                                        size="small"
                                        autoFocus={isScanBarcode === true}
                                        onChange={(e) => setSku(e.target.value)}
                                        onKeyPress={(e) => {
                                            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                            e.key === "Enter"
                                                ? setInputSku(sku)
                                                : undefined;
                                        }}
                                        sx={{
                                            width: isPhoneScreen
                                                ? undefined
                                                : 200,
                                        }}
                                        inputProps={{
                                            style: {
                                                height: 20,
                                            },
                                        }}
                                    />
                                </Stack>
                            )}
                        </Box>
                        <Box
                            className="hide-scroll"
                            marginX={2}
                            sx={{
                                overflowY: "auto",
                                height:
                                    cartOpenBill.length > 0 || cart.length > 0
                                        ? undefined
                                        : "100%",
                            }}
                        >
                            {cartOpenBill.length > 0 ? (
                                <Box
                                    height={
                                        isKeterangan
                                            ? "calc(100vh - 25rem)"
                                            : "calc(100vh - 20rem)"
                                    }
                                >
                                    {cartOpenBill.map((invoice) => (
                                        <Card
                                            key={invoice.nomorInvoice}
                                            variant="outlined"
                                            sx={{
                                                marginBottom: 1,
                                                padding: isTabletScreen ? 1 : 2,
                                                height: "95%",
                                            }}
                                        >
                                            <Box
                                                display="grid"
                                                className="card-openBill"
                                                mb={2}
                                            >
                                                <Typography
                                                    fontWeight={700}
                                                    fontSize={20}
                                                >
                                                    Open Bill
                                                </Typography>
                                                <Box
                                                    flexDirection="column"
                                                    width="100%"
                                                    mt={1}
                                                >
                                                    <Tooltip
                                                        title={
                                                            invoice.nomorInvoice
                                                        }
                                                    >
                                                        <Typography>
                                                            No. Invoice:{" "}
                                                            {
                                                                invoice.nomorInvoice
                                                            }
                                                        </Typography>
                                                    </Tooltip>
                                                </Box>
                                            </Box>

                                            {invoice.daftarItem &&
                                            invoice.daftarItem.length > 0 ? (
                                                <>
                                                    <Box
                                                        // className="hide-scroll"
                                                        // marginX={2}
                                                        // mt={2}
                                                        // mb={1}
                                                        sx={{
                                                            overflowY: "scroll",
                                                        }}
                                                    >
                                                        {cartItems.map(
                                                            (item) => (
                                                                <CardPesan
                                                                    key={
                                                                        item.id
                                                                    }
                                                                    id={item.id}
                                                                    namaBarang={
                                                                        item.namaBarang
                                                                    }
                                                                    namaKategori={
                                                                        item
                                                                            .kategori
                                                                            .nama
                                                                    }
                                                                    sku={String(
                                                                        item.sku,
                                                                    )}
                                                                    harga={
                                                                        item.harga
                                                                    }
                                                                    // jumlahStok={item.stok + item.jumlahItem}
                                                                    jumlahStok={
                                                                        item.stok ===
                                                                        null
                                                                            ? item.stok
                                                                            : item.stok +
                                                                              item.jumlahItem
                                                                    }
                                                                    url={
                                                                        item.url
                                                                    }
                                                                    qty={
                                                                        item.jumlahItem
                                                                    }
                                                                    detailBundling={
                                                                        item.detailBundling
                                                                    }
                                                                    hpp={
                                                                        item.hpp
                                                                    }
                                                                    multipleHarga={
                                                                        item.hargaMultiple
                                                                    }
                                                                    onRemoveItem={
                                                                        handleRemoveFromCartItems
                                                                    }
                                                                    keteranganItem={
                                                                        item.keteranganItem
                                                                    }
                                                                    hargaSatuan={
                                                                        item.hargaSatuan
                                                                    }
                                                                />
                                                            ),
                                                        )}

                                                        {cart
                                                            .filter(
                                                                (rows) =>
                                                                    !cartItems.some(
                                                                        (
                                                                            item,
                                                                        ) =>
                                                                            item.id ===
                                                                            rows.id,
                                                                    ),
                                                            )
                                                            .map((rows) => (
                                                                <CardPesan
                                                                    key={
                                                                        rows.id
                                                                    }
                                                                    id={rows.id}
                                                                    namaBarang={
                                                                        rows.namaBarang
                                                                    }
                                                                    namaKategori={
                                                                        rows.namaKategori
                                                                    }
                                                                    sku={String(
                                                                        rows.sku,
                                                                    )}
                                                                    harga={
                                                                        rows.harga
                                                                    }
                                                                    jumlahStok={
                                                                        rows.jumlahStok
                                                                    }
                                                                    url={
                                                                        rows.url
                                                                    }
                                                                    qty={
                                                                        rows.qty
                                                                    }
                                                                    detailBundling={
                                                                        rows.detailBundling
                                                                    }
                                                                    hpp={
                                                                        rows.hpp
                                                                    }
                                                                    multipleHarga={
                                                                        rows.multipleHarga
                                                                    }
                                                                    keteranganItem={
                                                                        rows.keteranganItem
                                                                    }
                                                                    hargaSatuan={
                                                                        rows.hargaSatuan
                                                                    }
                                                                />
                                                            ))}
                                                    </Box>
                                                </>
                                            ) : (
                                                <Box
                                                    display="flex"
                                                    flex={1}
                                                    flexDirection="column"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    height="100%"
                                                >
                                                    <BelumAdaPesanan
                                                        width={
                                                            isTabletScreen
                                                                ? "20%"
                                                                : "50%"
                                                        }
                                                        style={{
                                                            height: "fit-content",
                                                        }}
                                                    />
                                                    <Typography
                                                        marginTop={
                                                            isTabletScreen
                                                                ? 2
                                                                : isPhoneScreen
                                                                  ? 1
                                                                  : 5
                                                        }
                                                        variant={
                                                            isTabletScreen ||
                                                            isPhoneScreen
                                                                ? "body2"
                                                                : "h6"
                                                        }
                                                        fontWeight="bold"
                                                    >
                                                        Tambahkan Pesanan Anda
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Card>
                                    ))}
                                </Box>
                            ) : cart.length > 0 ? (
                                cart.map((rows) => (
                                    // <Box
                                    //     height={
                                    //         isKeterangan
                                    //             ? "calc(100vh - 25rem)"
                                    //             : "calc(100vh - 20rem)"
                                    //     }
                                    // >
                                    <CardPesan
                                        key={rows.id}
                                        id={rows.id}
                                        namaBarang={rows.namaBarang}
                                        namaKategori={rows.namaKategori}
                                        sku={String(rows.sku)}
                                        harga={rows.harga}
                                        jumlahStok={rows.jumlahStok}
                                        url={rows.url}
                                        qty={rows.qty}
                                        detailBundling={rows.detailBundling}
                                        hpp={rows.hpp}
                                        multipleHarga={rows.multipleHarga}
                                        keteranganItem={rows.keteranganItem}
                                        hargaSatuan={rows.hargaSatuan}
                                    />
                                    // </Box>
                                ))
                            ) : (
                                <Box
                                    display="flex"
                                    flex={1}
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    height="100%"
                                >
                                    <BelumAdaPesanan
                                        width={isTabletScreen ? "20%" : "50%"}
                                        style={{ height: "fit-content" }}
                                    />
                                    <Typography
                                        marginTop={
                                            isTabletScreen
                                                ? 2
                                                : isPhoneScreen
                                                  ? 1
                                                  : 5
                                        }
                                        variant={
                                            isTabletScreen || isPhoneScreen
                                                ? "body2"
                                                : "h6"
                                        }
                                        fontWeight="bold"
                                    >
                                        Belum ada pesanan
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </React.Fragment>
                )}

                {section === SectionPesan.OpenBill && (
                    <React.Fragment>
                        <Box>
                            <Box
                                display="grid"
                                gridTemplateColumns="1fr auto"
                                marginX={2}
                                marginY={1}
                                gap={2}
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Stack spacing={1} paddingX={2} mt={1}>
                                    <TextField
                                        placeholder="Cari transaksi Open Bill..."
                                        size="small"
                                        fullWidth
                                        value={search}
                                        onChange={(e) =>
                                            setSearch(e.target.value)
                                        }
                                        onKeyPress={(e) => {
                                            const element =
                                                e.target as HTMLInputElement;
                                            if (e.key === "Enter") {
                                                setParamsItem((prev) => ({
                                                    ...prev,
                                                    search: element.value,
                                                    page: 1,
                                                }));
                                            }
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                    // onClick={handleSearch}
                                                    >
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        variant="outlined"
                                    />
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        flexWrap="wrap"
                                    >
                                        <Box width={276}>
                                            <Select
                                                value={
                                                    paramsListOpenBill.tanggalAwal ===
                                                        now ||
                                                    paramsListOpenBill.tanggalAwal ===
                                                        moment()
                                                            .subtract(7, "days")
                                                            .format(
                                                                "YYYY-MM-DD",
                                                            ) ||
                                                    paramsListOpenBill.tanggalAwal ===
                                                        moment()
                                                            .subtract(
                                                                1,
                                                                "month",
                                                            )
                                                            .format(
                                                                "YYYY-MM-DD",
                                                            ) ||
                                                    paramsListOpenBill.tanggalAwal ===
                                                        moment()
                                                            .subtract(
                                                                3,
                                                                "months",
                                                            )
                                                            .format(
                                                                "YYYY-MM-DD",
                                                            ) ||
                                                    paramsListOpenBill.tanggalAwal ===
                                                        moment()
                                                            .subtract(
                                                                1,
                                                                "years",
                                                            )
                                                            .format(
                                                                "YYYY-MM-DD",
                                                            )
                                                        ? paramsListOpenBill.tanggalAwal
                                                        : "Custom"
                                                }
                                                size="small"
                                                sx={{
                                                    borderRadius: 2,
                                                }}
                                                fullWidth
                                                onChange={
                                                    handleChangePeriodeOpenBill
                                                }
                                            >
                                                <MenuItem value={now}>
                                                    Hari ini
                                                </MenuItem>
                                                <MenuItem
                                                    value={moment()
                                                        .subtract(7, "days")
                                                        .format("YYYY-MM-DD")}
                                                >
                                                    1 Minggu Terakhir
                                                </MenuItem>
                                                <MenuItem
                                                    value={moment()
                                                        .subtract(1, "month")
                                                        .format("YYYY-MM-DD")}
                                                >
                                                    1 Bulan Terakhir
                                                </MenuItem>

                                                <MenuItem
                                                    value={"Custom"}
                                                    sx={{ display: "none" }}
                                                >
                                                    Custom
                                                </MenuItem>
                                            </Select>
                                        </Box>
                                        <Box width={276}>
                                            <DatePicker
                                                className="range-filter"
                                                dateFormat="dd/MM/yyyy"
                                                disabledKeyboardNavigation
                                                onFocus={(e) => e.target.blur()}
                                                selectsRange={true}
                                                startDate={startDate}
                                                endDate={endDate}
                                                onChange={(update) => {
                                                    setDateRange(update);
                                                    if (update[1]) {
                                                        handleChangeJangkaWaktuOpenBill(
                                                            moment(
                                                                update[0],
                                                            ).format(
                                                                "YYYY/MM/DD",
                                                            ),
                                                            moment(
                                                                update[1],
                                                            ).format(
                                                                "YYYY/MM/DD",
                                                            ),
                                                        );
                                                    }
                                                }}
                                                maxDate={today}
                                                minDate={subtractYears(1)}
                                                monthsShown={
                                                    isPhoneScreen ? 1 : 2
                                                }
                                                customInput={
                                                    <Stack
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        direction="row"
                                                        width="100%"
                                                        bgcolor="#FFFF"
                                                        height="40px"
                                                        sx={{
                                                            border: "1px solid #cbcbcb",
                                                            borderRadius: "8px",
                                                            alignItems:
                                                                "center",
                                                            paddingX: 2,
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <Typography>
                                                            {moment(
                                                                paramsListOpenBill.tanggalAwal,
                                                            ).format(
                                                                "DD/MM/YYYY",
                                                            )}{" "}
                                                            -{" "}
                                                            {paramsListOpenBill.tanggalAkhir &&
                                                                moment(
                                                                    paramsListOpenBill.tanggalAkhir,
                                                                ).format(
                                                                    "DD/MM/YYYY",
                                                                )}
                                                        </Typography>
                                                        <ExpandMoreIcon
                                                            sx={{
                                                                marginRight:
                                                                    "-9px",
                                                                color: "#757575",
                                                            }}
                                                        />
                                                    </Stack>
                                                }
                                            />
                                        </Box>
                                    </Stack>
                                </Stack>
                            </Box>
                        </Box>
                        <Box
                            className="hide-scroll"
                            marginX={2}
                            sx={{
                                overflowY: "auto",
                                height:
                                    filteredInvoicesOpenBill.length > 0
                                        ? undefined
                                        : "100%",
                            }}
                        >
                            {isLoadingListOpenBill ? (
                                <Box
                                    display="flex"
                                    flex={1}
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    height="100%"
                                >
                                    <img
                                        src={logoUloGif}
                                        height="100px"
                                        width="100px"
                                        style={{ objectFit: "contain" }}
                                        alt="loading..."
                                    />
                                </Box>
                            ) : filteredInvoicesOpenBill.length > 0 ? (
                                <Box mt={1} height="calc(100vh - 23rem)">
                                    {filteredInvoicesOpenBill.map((li) => (
                                        <Box key={li.id}>
                                            <CardInvoiceTransaction
                                                detailInvoiceId={li.id}
                                                noInvoice={li.nomorInvoice}
                                                tanggalInvoice={li.tanggal}
                                                hargaPenjualan={
                                                    li.uangYangDibayar
                                                }
                                                isReverted={li.isReverted}
                                                refetchListInvoice={
                                                    refetchListInvoice
                                                }
                                                isPiutang={li.isPiutang}
                                                totalPiutang={li.totalPiutang}
                                                isOpenBill={li.isOpenBill}
                                                totalOpenBill={
                                                    li.hargaPenjualan
                                                }
                                                metode={li.metode ?? "Tunai"}
                                                daftarItem={li.daftarItem}
                                                handleAddToCart={
                                                    handleAddToCart
                                                }
                                                handleAddToCartEndOpenBill={
                                                    handleAddToCartEndOpenBill
                                                }
                                                ketBeli={li.keterangan}
                                            />
                                        </Box>
                                    ))}
                                </Box>
                            ) : (
                                <Box
                                    display="flex"
                                    flex={1}
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    height="100%"
                                >
                                    <BelumAdaPesanan
                                        width={isTabletScreen ? "20%" : "50%"}
                                        style={{
                                            height: "fit-content",
                                        }}
                                    />
                                    <Typography
                                        marginTop={
                                            isTabletScreen
                                                ? 2
                                                : isPhoneScreen
                                                  ? 1
                                                  : 5
                                        }
                                        variant={
                                            isTabletScreen || isPhoneScreen
                                                ? "body2"
                                                : "h6"
                                        }
                                        fontWeight="bold"
                                    >
                                        Belum ada transaksi
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </React.Fragment>
                )}

                {section === SectionPesan.Invoice && (
                    <React.Fragment>
                        <Typography
                            variant={isTabletScreen ? "body2" : "h6"}
                            fontSize={isPhoneScreen ? "18px" : undefined}
                            fontWeight="bold"
                            marginX={2}
                            marginY={3}
                        >
                            Daftar Transaksi
                        </Typography>
                        <Box
                            className="hide-scroll"
                            marginX={2}
                            sx={{
                                overflowY: "scroll",
                            }}
                        >
                            {listInvoice && listInvoice.totalElements > 0 ? (
                                listInvoice.content.map((li) => (
                                    // <CardInvoice
                                    //     key={li.id}
                                    //     detailInvoiceId={li.id}
                                    //     noInvoice={li.nomorInvoice}
                                    //     tanggalInvoice={li.tanggal}
                                    //     hargaPenjualan={li.uangYangDibayar}
                                    //     isReverted={li.isReverted}
                                    //     metode={li.metode ?? "Tunai"}
                                    //     member={li.member}
                                    //     noPolisi={li.noPolisi}
                                    // />

                                    <CardInvoiceTransaction
                                        detailInvoiceId={li.id}
                                        noInvoice={li.nomorInvoice}
                                        tanggalInvoice={li.tanggal}
                                        hargaPenjualan={li.uangYangDibayar}
                                        isReverted={li.isReverted}
                                        refetchListInvoice={refetchListInvoice}
                                        isPiutang={li.isPiutang}
                                        totalPiutang={li.totalPiutang}
                                        isOpenBill={li.isOpenBill}
                                        totalOpenBill={li.hargaPenjualan}
                                        metode={li.metode ?? "Tunai"}
                                        daftarItem={li.daftarItem}
                                        handleAddToCart={handleAddToCart}
                                        handleAddToCartEndOpenBill={
                                            handleAddToCartEndOpenBill
                                        }
                                        ketBeli={li.keterangan}
                                    />
                                ))
                            ) : (
                                <Box
                                    display="flex"
                                    flex={1}
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    height="100%"
                                >
                                    <BelumAdaPesanan
                                        width={isTabletScreen ? "20%" : "50%"}
                                        style={{ height: "fit-content" }}
                                    />
                                    <Typography
                                        marginTop={
                                            isTabletScreen
                                                ? 2
                                                : isPhoneScreen
                                                  ? 1
                                                  : 5
                                        }
                                        variant={
                                            isTabletScreen || isPhoneScreen
                                                ? "body2"
                                                : "h6"
                                        }
                                        fontWeight="bold"
                                    >
                                        Belum ada transaksi
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </React.Fragment>
                )}

                {section === SectionPesan.Piutang && (
                    <React.Fragment>
                        <Typography
                            variant={isTabletScreen ? "body2" : "h6"}
                            fontSize={isPhoneScreen ? "18px" : undefined}
                            fontWeight="bold"
                            marginX={2}
                            mt={3}
                        >
                            Daftar Piutang
                        </Typography>
                        <Box
                            className="hide-scroll"
                            // marginX={2}
                            sx={{
                                overflowY: "scroll",
                            }}
                        >
                            <DaftarPiutang
                                params={piutangParams}
                                setParams={setPiutangParams}
                            />
                        </Box>
                    </React.Fragment>
                )}
            </Box>

            <Divider />

            <Box paddingX={2} paddingY={isTabletScreen ? 1 : 2}>
                <Box paddingX={2} paddingY={isTabletScreen ? 1 : 2}>
                    <Box display="flex" justifyContent="space-between">
                        <Typography fontWeight={500}>
                            {selectedDebt
                                ? "Piutang Terpilih"
                                : "Subtotal Harga"}
                        </Typography>

                        <Typography fontSize={20} fontWeight={500}>
                            {selectedDebt
                                ? debt?.content.find(
                                      (d) => d.id === selectedDebt,
                                  )?.nomorInvoice
                                : toRupiah(totalHarga)}
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Stack direction="row" spacing={1} flexWrap="wrap" paddingX={2}>
                <Box paddingBottom={isTabletScreen ? 1 : 2}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isKeterangan}
                                size={isTabletScreen ? "small" : undefined}
                                onChange={(_, checked) => {
                                    handleIsKeterangan(checked);
                                }}
                            />
                        }
                        label="Tambah Keterangan"
                        componentsProps={{
                            typography: {
                                fontSize: isTabletScreen ? "12px" : undefined,
                            },
                        }}
                        sx={{
                            height: "fit-content",
                        }}
                    />
                </Box>

                {section === SectionPesan.Keranjang && openBill === 1 && (
                    <Box paddingBottom={isTabletScreen ? 1 : 2}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={printStruk}
                                    size={isTabletScreen ? "small" : undefined}
                                    onChange={(_, checked) => {
                                        handlePrintStruk(checked);
                                    }}
                                />
                            }
                            label="Print struk"
                            componentsProps={{
                                typography: {
                                    fontSize: isTabletScreen
                                        ? "12px"
                                        : undefined,
                                },
                            }}
                            sx={{
                                height: "fit-content",
                            }}
                        />
                    </Box>
                )}
            </Stack>

            <Box
                width="100%"
                paddingX={2}
                paddingBottom={isTabletScreen ? 1 : 2}
            >
                {isKeterangan && (
                    <TextField
                        label="Keterangan"
                        multiline
                        rows={2}
                        fullWidth
                        size={isTabletScreen ? "small" : undefined}
                        value={keteranganBeli}
                        onChange={handleChangeKeteranganBeli}
                        helperText={`${keteranganBeli?.length}/50`}
                        inputProps={{ maxLength: 50 }}
                        sx={{
                            mb: 1,
                        }}
                    />
                )}

                {printStruk &&
                    section === SectionPesan.Keranjang &&
                    openBill === 1 && (
                        <ToggleButtonGroup
                            value={tipeStruk}
                            exclusive
                            size="small"
                            onChange={handleTipeStruk}
                            sx={{
                                mb: 1,
                            }}
                        >
                            <ToggleButton
                                value={TipeStruk.MobileDapur}
                                sx={{
                                    display: "flex",
                                    paddingX: 2,
                                    textTransform: "none",
                                }}
                            >
                                <b>A8 58mm Dapur</b>
                            </ToggleButton>
                            <ToggleButton
                                value={TipeStruk.Mobile80Dapur}
                                sx={{
                                    display: "flex",
                                    paddingX: 2,
                                    textTransform: "none",
                                }}
                            >
                                <b>A8 80mm Dapur</b>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    )}
            </Box>

            <Box marginX={2} marginBottom={isTabletScreen ? 1 : 2}>
                <Stack direction="row" spacing={2} alignItems="center">
                    {selectedDebt ? (
                        <>
                            <Button
                                variant="outlined"
                                onClick={() => setSelectedDebt(null)}
                                startIcon={<ReplayIcon />}
                                size={isTabletScreen ? "small" : "large"}
                                fullWidth
                            >
                                Batalkan
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleDebtPayment}
                                startIcon={<PayIcon />}
                                size={isTabletScreen ? "small" : "large"}
                                fullWidth
                                disabled={!selectedDebt}
                            >
                                Pembayaran
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    resetCart();
                                    handleReset();
                                    setCartOpenBill([]);

                                    if (openBill !== 1) {
                                        localStorage.removeItem(
                                            `openBill_${ukmId}`,
                                        );
                                    } else {
                                        localStorage.setItem(
                                            `openBill_${ukmId}`,
                                            JSON.stringify({
                                                openBill: 1,
                                                cart: [],
                                                ukmId,
                                            }),
                                        );
                                    }
                                }}
                                startIcon={
                                    cartOpenBill.length > 0 ? (
                                        <ArrowBackIcon />
                                    ) : (
                                        <DeleteIcon />
                                    )
                                }
                                size={isTabletScreen ? "small" : "large"}
                                fullWidth
                            >
                                {cartOpenBill.length > 0
                                    ? "Kembalikan"
                                    : "Kosongkan"}
                            </Button>

                            {printStruk ? (
                                tipeStruk === TipeStruk.MobileDapur ||
                                tipeStruk === TipeStruk.Mobile80Dapur ? (
                                    <BlobProvider
                                        document={
                                            <PrintStrukDapur
                                                is80mm={
                                                    tipeStruk ===
                                                    TipeStruk.Mobile80Dapur
                                                }
                                                isIncludeDapur={isIncludeDapur}
                                                namaToko={String(
                                                    ukmData?.namaToko,
                                                )}
                                                alamatToko={String(
                                                    ukmData?.alamatToko,
                                                )}
                                                gambarToko={
                                                    ukmData?.gambarTokoBW ===
                                                    null
                                                        ? undefined
                                                        : ukmData?.gambarTokoBW
                                                }
                                                telpToko={String(
                                                    ukmData?.noTelp,
                                                )}
                                                tanggalTransaksi={nowDapur}
                                                transaksiKe={String(
                                                    transaksiKe,
                                                )}
                                                kasir={String(
                                                    user?.namaLengkap,
                                                )}
                                                cart={
                                                    updatedCart &&
                                                    updatedCart.length > 0
                                                        ? updatedCart
                                                        : cart
                                                }
                                                keteranganBeli={
                                                    keteranganBeli ?? ""
                                                }
                                            />
                                        }
                                    >
                                        {({ blob, url, loading, error }) => (
                                            <LoadingButton
                                                loading={
                                                    loading || isButtonLoading
                                                }
                                                loadingPosition="center"
                                                variant="contained"
                                                fullWidth
                                                size={
                                                    isTabletScreen
                                                        ? "medium"
                                                        : "large"
                                                }
                                                disabled={cart.length < 1}
                                                onClick={() => {
                                                    if (blob) {
                                                        const blobFile =
                                                            new File(
                                                                [blob],
                                                                `Invoice_${ukmData?.namaToko}_${now}.pdf`,
                                                                {
                                                                    type: "application/pdf",
                                                                },
                                                            );
                                                        const invoiceUrl =
                                                            window.URL.createObjectURL(
                                                                blobFile,
                                                            );
                                                        console.log(invoiceUrl);
                                                        window.open(invoiceUrl);
                                                    }
                                                    cartOpenBill.length > 0
                                                        ? handlingUpdateOpenBill()
                                                        : openBill === 1
                                                          ? handlingOpenBill()
                                                          : openModalBayar();
                                                }}
                                            >
                                                Pesan
                                            </LoadingButton>
                                        )}
                                    </BlobProvider>
                                ) : (
                                    <LoadingButton
                                        variant="contained"
                                        loading={isButtonLoading}
                                        onClick={() =>
                                            cartOpenBill.length > 0
                                                ? handlingUpdateOpenBill()
                                                : openBill === 1
                                                  ? handlingOpenBill()
                                                  : openModalBayar()
                                        }
                                        startIcon={<PayIcon />}
                                        size={
                                            isTabletScreen ? "small" : "large"
                                        }
                                        fullWidth
                                        disabled={cart.length < 1}
                                    >
                                        {cartOpenBill.length > 0
                                            ? "Update"
                                            : openBill === 1
                                              ? "Pesan"
                                              : "Pembayaran"}
                                    </LoadingButton>
                                )
                            ) : (
                                <LoadingButton
                                    variant="contained"
                                    loading={isButtonLoading}
                                    onClick={() =>
                                        cartOpenBill.length > 0
                                            ? handlingUpdateOpenBill()
                                            : openBill === 1
                                              ? handlingOpenBill()
                                              : openModalBayar()
                                    }
                                    startIcon={<PayIcon />}
                                    size={isTabletScreen ? "small" : "large"}
                                    fullWidth
                                    disabled={cart.length < 1}
                                >
                                    {cartOpenBill.length > 0
                                        ? "Update"
                                        : openBill === 1
                                          ? "Pesan"
                                          : "Pembayaran"}
                                </LoadingButton>
                            )}

                            {/* <Button
                                variant="contained"
                                // onClick={() => openModalBayar()}
                                onClick={() => {
                                    if (openBill === 1) {
                                        setOpenBill(1);
                                    }
                                    openModalBayar();
                                }}
                                startIcon={<PayIcon />}
                                size={isTabletScreen ? "small" : "large"}
                                fullWidth
                                disabled={cart.length < 1}
                            >
                                {openBill === 1 ? "Pesan" : "Pembayaran"}
                            </Button> */}
                        </>
                    )}
                </Stack>
            </Box>

            <ModalBayar handlingRincianPembayaran={handlingRincianPembayaran} />
            <ModalKonfirmasiBayar
                kasir={String(user?.namaLengkap)}
                sales={sales}
                diskon={diskon}
                persentaseDiskon={persentaseDiskon}
                pajak={pajak}
                persentasePajak={persentasePajak}
                serviceCustom={service}
                serviceCustomPersen={persentaseService}
                totalTagihan={Number(tagihan)}
                uangDibayar={Number(uangDibayar)}
                kembalian={Number(kembalian)}
                refetch={refetchItem}
                keteranganBeli={keteranganBeli}
                resetKeteranganBeli={resetKeteranganBeli}
            />
        </React.Fragment>
    );
};

export default ListPesan;
